import { useEffect, useId, useRef, useState } from "react";
import { DialogActions, DialogContent, DialogTitle, useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { MonitorButton, MonitorDialog } from "./MonitorControls";
import PromotionArtifactDeployments from "./PromotionArtifactDeployments";
import { stageLabel } from "../utils/stages";

export function usePackageContentsNavigation() {
  const [contents, setContents] = useState(null);
  const opener = useRef(null);
  const showContents = (item, trigger) => {
    const peers = [...(trigger?.closest("[role=dialog]")?.querySelectorAll("[data-package-contents]") || [])].filter(button => button.dataset.packageContents === item.packageId);
    opener.current = { trigger, packageId: item.packageId, index: Math.max(0, peers.indexOf(trigger)) }; setContents(item);
  };
  const closeContents = () => { setContents(null); requestAnimationFrame(() => {
    const previous = opener.current;
    const target = previous?.trigger?.isConnected ? previous.trigger : [...document.querySelectorAll("[data-package-contents]")].filter(button => button.dataset.packageContents === previous?.packageId && button.closest("[role=dialog]"))[previous?.index || 0];
    target?.focus();
  }); };
  return { contents, showContents, closeContents };
}

export function PackageContentsView({ item, onClose, back = false, children }) {
  const { t } = useTranslation("freigabe");
  const heading = useRef(null);
  const titleId = useId();
  useEffect(() => { heading.current?.focus(); }, []);
  const groups = item.stagePackages?.length ? item.stagePackages : [item];
  return <>
    <DialogTitle id={titleId} ref={heading} tabIndex={-1}>{t("promotion.contents")}: {item.packageName || item.packageId}</DialogTitle>
    <DialogContent className="promotion-package-contents-body">
      <p className="promotion-package-id">{item.packageId}</p>
      {groups.map((group, index) => <section key={group.id || `${group.sourceStage || ""}-${index}`}>
        {group.sourceStage && <h3>{t("topics.memberStage", { stage: stageLabel(group.sourceStage) })}</h3>}
        <PromotionArtifactDeployments artifacts={group.artifacts} artifactIds={group.artifactIds} designArtifacts={group.designArtifacts}/>
      </section>)}
      {children}
    </DialogContent>
    <DialogActions><MonitorButton autoFocus onClick={onClose}>{t(back ? "gemeinsam:aktion.zurueck" : "gemeinsam:aktion.schliessen")}</MonitorButton></DialogActions>
  </>;
}

export default function PromotionPackageContents({ item, onOpen, children, compact = false }) {
  const { t } = useTranslation("freigabe");
  const [open, setOpen] = useState(false);
  const trigger = useRef(null);
  const close = () => { setOpen(false); requestAnimationFrame(() => trigger.current?.focus()); };
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("sm"));
  return <>
    <MonitorButton ref={trigger} data-package-contents={item.packageId} aria-haspopup="dialog" size={compact ? "small" : undefined} className={compact ? "promotion-contents-trigger--compact" : ""} onClick={event => onOpen ? onOpen(item, event.currentTarget) : setOpen(true)}>{t("promotion.contents")}</MonitorButton>
    {open && <MonitorDialog className="promotion-dialog promotion-package-contents-dialog" maxWidth="lg" fullScreen={mobile}
      aria-label={`${t("promotion.contents")}: ${item.packageName || item.packageId}`} onClose={close}>
      <PackageContentsView item={item} onClose={close}>{children}</PackageContentsView>
    </MonitorDialog>}
  </>;
}
